class GDNoteView {

    constructor() {
        this.noteId = null;
        this.options = null;
    }

    getOptions() {
        return this.options ? this.options : {};
    }

    open(noteId, options) {
        this.noteId = noteId;
        _.assign(this.options, options);

        const path = window.location.pathname.split('/');
        const noteUrl = [path[1],'n', this.noteId].join('/');

        gd.goTo(noteUrl, this.options)
    }

    openWindow(noteId) {
        this.noteId = noteId;
        const path = window.location.pathname.split('/');
        const noteUrl = [path[1],'n', this.noteId].join('/');
        window.open('/' + noteUrl);
    }

    /*new(options) {
        const { projectId, noteTypeId } = options;
        gd.goTo('n/'+projectId+'/'+noteTypeId+'/new', {});
    }*/
}

module.exports = GDNoteView;